import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = loading; null = guest
  const [perms, setPerms] = useState({});

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("hbs_token");
    if (!token) {
      setUser(null);
      setPerms({});
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setPerms(data.permissions || {});
    } catch {
      localStorage.removeItem("hbs_token");
      setUser(null);
      setPerms({});
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hbs_token", data.access_token);
    setUser(data.user);
    setPerms(data.permissions || {});
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* noop */ }
    localStorage.removeItem("hbs_token");
    setUser(null);
    setPerms({});
    window.location.href = "/login";
  };

  const can = (key) => !!perms[key];

  return (
    <AuthContext.Provider value={{ user, perms, login, logout, can, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};
